import { useState } from 'react'

export function CopyBtn({ text }: { text: string }) {
  const [done, setDone] = useState(false)
  return (
    <button
      type="button"
      className="dep-copy"
      title="Sao chép"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text)
          setDone(true)
          window.setTimeout(() => setDone(false), 1500)
        } catch {
          /* ignore */
        }
      }}
    >
      <i className={`fa-solid ${done ? 'fa-check' : 'fa-copy'}`} aria-hidden />
    </button>
  )
}
